/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';
import ScSelectBase from './ScSelectBase';
import _ from 'lodash';
import stringUtils from '@app/utils/string.utils';
import RequiredIcon from '@app/components/UI/Icons/RequiredIcon';
import { SelectProps } from 'antd';

interface ScSingleSelectProps extends SelectProps {
    title?: string;
    dataSource?: Record<string, any>[];
    selectId?: string | number | boolean | any[];
    idField?: string;
    nameField?: string;
    onChange?: (value: any) => void;
    onItemChange?: (item: Record<string, any>) => void;
    isRequired?: boolean;
}

const ScSingleSelect = ({
    title,
    dataSource = [],
    selectId,
    idField,
    nameField,
    disabled,
    onItemChange,
    onChange,
    isRequired,
    ...props
}: ScSingleSelectProps) => {
    const listOption = useMemo(() => {
        if (
            _.isEmpty(dataSource) ||
            stringUtils.isEmpty(nameField) ||
            stringUtils.isEmpty(idField)
        ) {
            return [];
        }

        return dataSource.map((o) => ({
            label: o[nameField],
            value: o[idField],
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataSource]);

    const handleChange = (value) => {
        onChange?.(value);
        onItemChange?.(dataSource.find((o) => o[idField] === value) ?? {});
    };

    return (
        <>
            {!stringUtils.isEmpty(title) && (
                <label>
                    <h6 className="panel-title">
                        {title} {isRequired && <RequiredIcon />}
                    </h6>
                </label>
            )}
            <ScSelectBase
                value={selectId}
                onChange={handleChange}
                options={listOption}
                disabled={disabled}
                {...props}
            />
        </>
    );
};

export default ScSingleSelect;
